// ** Initial State
const initialState = {
  allLoginErrorData: [],
  blockedIpList: [],
  errorLogsList: [],
  data: []
}

const logs = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allLoginErrorData: action.data }
    case 'DELETE_LOGIN_ERRORS_LIST':
      return { ...state, allLoginErrorData: [] }
    case 'GET_BLOCKED_IP_LIST':
      return { ...state, blockedIpList: action.data }
    case 'GET_ERROR_LOGS_LIST':
      return { ...state, errorLogsList: action.data }
    case 'DELETE_ERROR_LOGS_LIST':
      return { ...state, errorLogsList: [] }
    case 'CHANGE_IP_STATUS':
      return { ...state }
    default:
      return { ...state }
  }
}
export default logs
